import React from 'react';
import { Input } from 'zarm';

import UItem from '../item';
import { isInWechat, clearObj, getFormId } from '../../utils/tools';
import { InputProps } from './type.d';
import ImageOCR from './imageOCR';
import AddressBook from './addressBook';
import OpenAddress from './openAddress';
import GroupTextArea from './groupTextArea';

// 表单 输入框组件
function UInput(props: InputProps) {
  const {
    prefixCls = 'crm-input',
    itemType = 'input',
    type,
    value,
    disabled,
    defaultValue,
    rows,
    autoHeight,
    maxLength,
    clearable,
    showLength,
    placeholder,
    readOnly,
    readonly,
    hiddenElem,
    description,
    imageOCR,
    addressBook,
    openAddress,
    _crengine,
    cell,
    onChange,
    onAddressBook,
    onLog,
    options,
    suffix,
    ...rest
  } = props;
  const newReadOnly = (readOnly || readonly);
  const { form, dataBind, path } = _crengine || {};
  const initialValue = (value || defaultValue || '');

  // 隐藏元素，form input隐藏值
  if (hiddenElem) {
    if (dataBind && form && initialValue) {
      return form.getFieldDecorator(getFormId(dataBind, path), {
        initialValue,
      })(
        <input type="hidden" />,
      );
    }

    return null;
  }

  // 子项内容改变的时候进行数据更新
  const onValueChange = (val: any, isReset: boolean = false) => {
    const { onChange: onChangeV, ...otherProps } = props;

    // 识别ocr结果，设置form value
    if (isReset && form) {
      const names = getFormId(dataBind, path);

      form.setFieldsValue({
        [names]: val,
      });
    }

    if (onChange) {
      onChange({
        ...otherProps,
        value: val,
      });
    }
  };

  const inputProps = clearObj({
    type,
    value,
    disabled,
    defaultValue,
    rows,
    autoHeight,
    maxLength,
    clearable,
    showLength,
    placeholder,
    readOnly: newReadOnly,
    options,
    onBlur: onValueChange,
  });

  const descNode: any[] = [];

  if (suffix) {
    descNode.push(suffix);
  }
  if (!newReadOnly) {
    // 客户导入，个险定制功能，使用需要自我验证。
    if (addressBook) {
      descNode.push(
        <AddressBook
          key="addressBook"
          prefixCls={prefixCls}
          dataSource={addressBook}
          path={path}
          onChange={(item) => onAddressBook && onAddressBook(props, item)}
          onLog={onLog}
        />,
      );
    }

    // 证件OCR识别，未测试
    if (imageOCR) {
      descNode.push(
        <ImageOCR
          key="imageOCR"
          prefixCls={prefixCls}
          type={imageOCR}
          onChange={(v) => onValueChange(v, true)}
          onLog={onLog}
        />,
      );
    }

    // 微信内，打开我的地址
    if (openAddress && isInWechat) {
      descNode.push(
        <OpenAddress
          key="openAddress"
          onChange={(v) => onValueChange(v, true)}
          onLog={onLog}
        />,
      );
    }
  }

  // 类型inputText组件，一组 textarea
  if (itemType === 'textarea' && options && Array.isArray(options) && options.length) {
    return <GroupTextArea {...props} />;
  }

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete inputProps.value;
    delete inputProps.defaultValue;
    // form onBlur node validate.rules
    // delete inputProps.onBlur;
  }

  return (
    <UItem
      itemType={itemType}
      readOnly={newReadOnly}
      {...rest}
      {...cell}
      _crengine={_crengine}
      description={descNode.length ? descNode : null}
      initialValue={initialValue}
      validateTrigger="onBlur"
      onBlur={onValueChange}
    >
      <Input {...inputProps} />
    </UItem>
  );
}

export default UInput;
